// Arkadaşlar + oyun daveti paneli ve gelen davet diyaloğu (Katıl/Reddet).
// React'ten bağımsız, body'ye eklenen DOM overlay'leri — ludo/UMO'daki
// friends.js ile aynı davranış: GET /v1/friends + GET/POST /v1/game-invitations
// (nativeBridge üzerinden, gameType 'batak'), seçilen masa yalnızca soket
// kanalında taşınır (REST daveti game-scoped'dır).
import {
    fetchFriendsList,
    fetchGameInvitations,
    sendGameInvite,
} from './nativeBridge';
import drawerBg from '../assets/invite_drawer_bg.png';
import drawerDivider from '../assets/invite_drawer_divider.png';

const ERROR_TR = {
    NOT_FRIENDS: 'Arkadaş değilsiniz',
    INVITEE_UNAVAILABLE: 'Bu kullanıcı şu an davet edilemiyor',
    INVITE_RATE_LIMITED: 'Çok sık davet gönderiyorsun, biraz bekle',
    INVITE_LIMIT_REACHED: 'Bekleyen davet sınırına ulaştın',
    INVITES_DISABLED: 'Davetler şu an kapalı',
    SELF_INVITE: 'Kendini davet edemezsin',
    INVALID_GAME_TYPE: 'Geçersiz oyun',
    INVALID_CALLER_ID: 'Geçersiz kullanıcı',
    UNAUTHORIZED: 'Oturum doğrulanamadı',
};

// invite_firend_drawer tasarımı: sağdan açılan simsiyah, ince altın çerçeveli
// çekmece — ortalı başlık + süslü ayraç, altın konturlu arkadaş satırları,
// yeşil Davet Et hapları.
const STYLE_ID = 'batak-invite-styles';
const CSS = `
#batak-friends-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 9980; display: none; }
#batak-friends-overlay.visible { display: block; }
#batak-friends {
  position: fixed; top: calc(env(safe-area-inset-top, 0px) + 8px); right: 5px;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 8px); width: min(72vw, 320px);
  background: url(${drawerBg}) center / 100% 100% no-repeat;
  z-index: 9981; box-shadow: -8px 0 26px rgba(0,0,0,0.55);
  display: none; flex-direction: column; color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  padding: 14px 13px calc(env(safe-area-inset-bottom, 0px) * 0.4 + 12px) 13px;
}
#batak-friends.visible { display: flex; }
#batak-friends-header { position: relative; display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 22px 0 12px; }
#batak-friends-header h3 { margin: 0; font-size: 17px; font-weight: 500; letter-spacing: 0.02em; color: #f3ead0; font-family: Georgia, 'Times New Roman', serif; }
#batak-friends-header .batak-friends-kit { width: 82%; height: auto; display: block; }
#batak-friends-close { position: absolute; top: -4px; right: -3px; width: 32px; height: 32px; border-radius: 50%; border: 2px solid #e9c25f; background: radial-gradient(circle at 35% 30%, #1d5232, #0b2917 72%); color: #f3d47a; font-size: 15px; font-weight: 700; line-height: 1; cursor: pointer; padding: 0; box-shadow: 0 2px 8px rgba(0,0,0,0.6); }
#batak-friends-list { flex: 1; overflow-y: auto; padding: 6px 2px; touch-action: pan-y; -webkit-overflow-scrolling: touch; }
#batak-friends-footer { padding: 10px 0 2px; }
#batak-friends-footer img { width: 82%; height: auto; display: block; margin: 0 auto; }
.batak-friends-status { padding: 20px 8px; text-align: center; color: #b6ad93; font-size: 13.5px; line-height: 1.5; }
.batak-friend-row { display: flex; align-items: center; gap: 9px; padding: 7px 9px; margin-bottom: 9px; border: 1px solid rgba(214, 195, 140, 0.4); border-radius: 14px; background: rgba(255,255,255,0.025); }
.batak-friend-avatar { width: 40px; height: 40px; border-radius: 50%; overflow: hidden; background: #23402c; border: 1.5px solid rgba(212,168,67,0.55); flex: none; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 16px; color: #ffd98a; }
.batak-friend-avatar img { width: 100%; height: 100%; object-fit: cover; }
.batak-friend-name { flex: 1; min-width: 0; font-size: 13.5px; font-weight: 600; color: #f4efe2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.batak-friend-invite { flex: none; min-width: 88px; height: 32px; padding: 0 12px; border: none; border-radius: 999px; background: linear-gradient(180deg, #4fd977, #2aa14b); color: #fff; font-weight: 700; font-size: 12px; cursor: pointer; box-shadow: 0 2px 6px rgba(0,0,0,0.4); }
.batak-friend-invite:active { transform: scale(0.95); }
.batak-friend-invite[disabled] { opacity: 0.55; }
.batak-friend-invite.pending { background: rgba(9, 28, 16, 0.9); border: 1px solid rgba(212,168,67,0.5); color: #ffd98a; }
#batak-friends-toast { position: absolute; left: 14px; right: 14px; bottom: calc(env(safe-area-inset-bottom,0px) + 14px); background: rgba(6, 20, 11, 0.97); border: 1px solid rgba(212,168,67,0.6); color: #ffb4ab; border-radius: 12px; padding: 10px 12px; font-size: 13px; text-align: center; display: none; z-index: 2; }
#batak-invite-toast { position: fixed; left: 50%; transform: translateX(-50%); bottom: calc(env(safe-area-inset-bottom,0px) + 24px); background: rgba(6, 20, 11, 0.97); border: 1px solid rgba(24,201,89,0.5); color: #e9e2cd; border-radius: 12px; padding: 10px 16px; font-size: 13px; z-index: 9998; display: none; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
`;

const ensureDom = () => {
    if (!document.getElementById(STYLE_ID)) {
        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = CSS;
        document.head.appendChild(style);
    }
    if (!document.getElementById('batak-friends')) {
        const overlay = document.createElement('div');
        overlay.id = 'batak-friends-overlay';
        const panel = document.createElement('div');
        panel.id = 'batak-friends';
        panel.innerHTML =
            '<div id="batak-friends-header">' +
                '<h3>Arkadaşlarını Davet Et</h3>' +
                '<img class="batak-friends-kit" src="' + drawerDivider + '" alt="">' +
                '<button id="batak-friends-close">✕</button>' +
            '</div>' +
            '<div id="batak-friends-list"></div>' +
            '<div id="batak-friends-footer"><img src="' + drawerDivider + '" alt=""></div>' +
            '<div id="batak-friends-toast"></div>';
        document.body.appendChild(overlay);
        document.body.appendChild(panel);
        overlay.onclick = closeInvitePanel;
        panel.querySelector('#batak-friends-close').onclick = closeInvitePanel;
    }
};

const state = {
    open: false,
    loading: false,
    friends: [],       // [{callerId, name, avatarUrl}]
    pending: {},       // callerId -> {invitationId, expiresAtMs}
    rowButtons: {},    // callerId -> <button>
    timer: null,
    toastTimer: null,
    opts: null,        // { socket, getRooms, myUserId, fixedRoomId }
};

const pickStr = (row, keys) => {
    for (const k of keys) {
        const v = row[k];
        if (v != null && v !== '') return String(v);
    }
    return '';
};

const extractPending = (inv) => {
    const map = {};
    const rows = (inv && inv.success && inv.data && inv.data.outgoing) || [];
    rows.forEach((row) => {
        if (!row) return;
        const gameType = pickStr(row, ['gameType', 'game_type']);
        if (gameType && gameType !== 'batak') return;
        const invitee = row.invitee || {};
        const callerId = pickStr(row, ['inviteeCallerId', 'invitee_caller_id', 'inviteeCallerid'])
            || pickStr(invitee, ['callerId', 'callerid', 'userId']);
        if (!callerId) return;
        const expiresAtMs = Number(pickStr(row, ['expiresAtMs', 'expires_at_ms'])) || 0;
        if (expiresAtMs && expiresAtMs <= Date.now()) return;
        map[callerId] = {
            invitationId: pickStr(row, ['invitationId', 'id', 'invitation_id']),
            expiresAtMs,
        };
    });
    return map;
};

const fmtRemain = (ms) => {
    const s = Math.max(0, Math.round(ms / 1000));
    if (s >= 3600) return Math.floor(s / 3600) + ' sa';
    if (s >= 60) return Math.floor(s / 60) + ' dk';
    return s + ' sn';
};

// Tanı raporu: API cevabını oyun sunucusunun /client-log ucuna yolla —
// docker logs'tan okunur (davet hatası ayıklaması, geçici olarak ayrıntılı).
const reportLog = (tag, payload) => {
    try {
        fetch('/client-log', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ tag, ts: new Date().toISOString(), ...payload }),
        }).catch(() => {});
    } catch (e) { /* tanı logu akışı bozmasın */ }
};

const panelToast = (msg) => {
    const t = document.getElementById('batak-friends-toast');
    if (!t) return;
    t.textContent = msg;
    t.style.display = 'block';
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(() => { t.style.display = 'none'; }, 3200);
};

const paintButton = (btn, callerId) => {
    if (btn.dataset.busy === '1') return;
    const p = state.pending[callerId];
    if (p && (!p.expiresAtMs || p.expiresAtMs > Date.now())) {
        btn.className = 'batak-friend-invite pending';
        btn.textContent = '↻ Davetli' + (p.expiresAtMs ? ' · ' + fmtRemain(p.expiresAtMs - Date.now()) : '');
    } else {
        if (p) delete state.pending[callerId];
        btn.className = 'batak-friend-invite';
        btn.textContent = '🎮 Davet Et';
    }
    btn.disabled = false;
};

const startTimer = () => {
    if (state.timer) return;
    state.timer = setInterval(() => {
        if (!state.open) { stopTimer(); return; }
        let any = false;
        Object.keys(state.rowButtons).forEach((cid) => {
            if (state.pending[cid]) any = true;
            paintButton(state.rowButtons[cid], cid);
        });
        if (!any) stopTimer();
    }, 1000);
};

const stopTimer = () => {
    if (state.timer) { clearInterval(state.timer); state.timer = null; }
};

const closeRoomPicker = () => {
    const el = document.getElementById('batak-room-picker');
    if (el) el.remove();
};

// Davet Et → açık masalardan seçim (sabit masa verildiyse veya masa yoksa direkt)
const invite = (f, btn) => {
    const opts = state.opts || {};
    if (opts.fixedRoomId) {
        sendInvite(f, btn, opts.fixedRoomId);
        return;
    }
    const rooms = ((opts.getRooms && opts.getRooms()) || [])
        .filter((r) => r.joinable)
        .slice(0, 5);
    if (rooms.length === 0) {
        sendInvite(f, btn, null);
        return;
    }
    openRoomPicker(f, btn, rooms);
};

const openRoomPicker = (f, btn, rooms) => {
    closeRoomPicker();
    const panel = document.getElementById('batak-friends');
    if (!panel) return;
    const myUserId = (state.opts && state.opts.myUserId) || '';

    const sheet = document.createElement('div');
    sheet.id = 'batak-room-picker';
    sheet.style.cssText = 'position:absolute;inset:0;z-index:3;background:rgba(5,11,6,0.98);' +
        'border:1px solid rgba(212,168,67,0.5);border-radius:18px;display:flex;flex-direction:column;gap:8px;' +
        'padding:16px 14px 14px;overflow-y:auto;';

    const title = document.createElement('div');
    title.style.cssText = 'font-size:15px;font-weight:700;padding-bottom:4px;';
    title.textContent = 'Hangi masaya davet edeceksin?';
    const sub = document.createElement('div');
    sub.style.cssText = 'font-size:12px;color:#b6ad93;padding-bottom:8px;border-bottom:1px solid rgba(212,168,67,0.3);';
    sub.textContent = f.name;
    sheet.appendChild(title);
    sheet.appendChild(sub);

    rooms.forEach((r, i) => {
        const mine = (r.players || []).some((p) => p && p.userId === myUserId);
        const row = document.createElement('button');
        row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:8px;' +
            'padding:12px 14px;border:1px solid rgba(' + (mine ? '24,201,89,0.55' : '214,195,140,0.4') + ');' +
            'border-radius:12px;background:rgba(255,255,255,0.035);color:#fff;cursor:pointer;text-align:left;';
        row.innerHTML =
            '<span style="font-weight:700;font-size:13.5px;">Masa ' + (i + 1) +
                (mine ? ' <span style="color:#3ddc84;font-size:11.5px;">· senin masan</span>' : '') + '</span>' +
            '<span style="color:#ffd98a;font-size:12.5px;font-weight:600;">' + r.count + '/' + r.capacity + '</span>';
        row.onclick = () => {
            closeRoomPicker();
            sendInvite(f, btn, r.roomId);
        };
        sheet.appendChild(row);
    });

    const cancel = document.createElement('button');
    cancel.style.cssText = 'margin-top:auto;height:40px;border:1px solid rgba(212,168,67,0.35);border-radius:12px;' +
        'background:rgba(9,28,16,0.9);color:#cbbf9e;font-weight:600;font-size:13px;cursor:pointer;';
    cancel.textContent = 'Vazgeç';
    cancel.onclick = closeRoomPicker;
    sheet.appendChild(cancel);

    panel.appendChild(sheet);
};

const sendInvite = async (f, btn, roomId) => {
    btn.dataset.busy = '1';
    btn.disabled = true;
    btn.textContent = '...';
    const result = await sendGameInvite(f.callerId);
    reportLog('invite-send', {
        ok: !!result.success,
        statusCode: result.statusCode,
        message: result.message,
        invitee: f.callerId,
        data: result.data,
    });
    btn.dataset.busy = '';
    if (!state.open) return;

    if (result.success && result.data) {
        state.pending[f.callerId] = {
            invitationId: result.data.invitationId,
            expiresAtMs: Number(result.data.expiresAtMs) || 0,
        };
        startTimer();
        // Davet edilen şu an oyundaysa soketten anlık dialog alsın
        const socket = state.opts && state.opts.socket;
        if (socket) {
            socket.emit('gameInviteNotify', {
                inviteeCallerId: f.callerId,
                invitationId: result.data.invitationId,
                roomId: roomId || null,
            });
        }
    } else {
        const err = (result.data && result.data.error) || {};
        // Tanı için geçici olarak ayrıntılı: HTTP durumu + API hata kodu görünür
        const detail = [
            result.statusCode ? 'HTTP ' + result.statusCode : '',
            err.code || '',
        ].filter(Boolean).join(' · ');
        panelToast((err.message || ERROR_TR[err.code] || result.message || 'Davet gönderilemedi')
            + (detail ? ' (' + detail + ')' : ''));
    }
    paintButton(btn, f.callerId);
};

const render = () => {
    const list = document.getElementById('batak-friends-list');
    if (!list) return;
    list.innerHTML = '';
    state.rowButtons = {};

    state.friends.forEach((f) => {
        const row = document.createElement('div');
        row.className = 'batak-friend-row';

        const avatar = document.createElement('div');
        avatar.className = 'batak-friend-avatar';
        const initial = (f.name[0] || '?').toUpperCase();
        if (f.avatarUrl) {
            const img = document.createElement('img');
            img.src = f.avatarUrl;
            img.onerror = () => { img.remove(); avatar.textContent = initial; };
            avatar.appendChild(img);
        } else {
            avatar.textContent = initial;
        }

        const name = document.createElement('div');
        name.className = 'batak-friend-name';
        name.textContent = f.name;

        const btn = document.createElement('button');
        btn.className = 'batak-friend-invite';
        btn.onclick = () => invite(f, btn);
        paintButton(btn, f.callerId);

        row.appendChild(avatar);
        row.appendChild(name);
        row.appendChild(btn);
        list.appendChild(row);
        state.rowButtons[f.callerId] = btn;
    });
};

const refresh = async () => {
    if (state.loading) return;
    const list = document.getElementById('batak-friends-list');
    if (!list) return;

    state.loading = true;
    list.innerHTML = '<div class="batak-friends-status">Arkadaşlar yükleniyor...</div>';

    const [fr, inv] = await Promise.all([fetchFriendsList(500), fetchGameInvitations()]);
    if (!fr || !fr.success) {
        reportLog('friends-load-fail', { statusCode: fr && fr.statusCode, message: fr && fr.message });
    }
    if (!inv || !inv.success) {
        reportLog('invitations-load-fail', { statusCode: inv && inv.statusCode, message: inv && inv.message, data: inv && inv.data });
    }
    state.loading = false;
    if (!state.open) return;

    state.friends = (fr && fr.friends) || [];
    state.pending = extractPending(inv);

    if (!fr || !fr.success) {
        list.innerHTML = fr && fr.message === 'no auth'
            ? '<div class="batak-friends-status">Davet gönderebilmek için uygulama üzerinden girmelisin.</div>'
            : '<div class="batak-friends-status">Arkadaş listesi alınamadı.<br>Bağlantını kontrol edip tekrar dene.</div>';
        return;
    }
    if (state.friends.length === 0) {
        list.innerHTML = '<div class="batak-friends-status">Henüz arkadaşın yok.<br>Oyun sırasında oyuncu profillerine dokunarak arkadaş ekleyebilirsin.</div>';
        return;
    }
    render();
    startTimer();
};

// ── Dışa açık API ─────────────────────────────────────────────────────────────

// opts: { socket, getRooms: () => rooms[], myUserId, fixedRoomId }
export const openInvitePanel = (opts = {}) => {
    ensureDom();
    state.opts = opts;
    state.open = true;
    document.getElementById('batak-friends').classList.add('visible');
    document.getElementById('batak-friends-overlay').classList.add('visible');
    refresh();
};

export const closeInvitePanel = () => {
    state.open = false;
    closeRoomPicker();
    stopTimer();
    const panel = document.getElementById('batak-friends');
    const overlay = document.getElementById('batak-friends-overlay');
    if (panel) panel.classList.remove('visible');
    if (overlay) overlay.classList.remove('visible');
};

// Gelen oyun daveti diyaloğu (Katıl / Reddet) — her sayfadan kullanılır.
export const showGameInviteDialog = (data, opts = {}) => {
    ensureDom();
    dismissGameInviteDialog();

    const bar = document.createElement('div');
    bar.id = 'batak-game-invite';
    bar.style.cssText = 'position:fixed;top:env(safe-area-inset-top,12px);left:12px;right:12px;z-index:9999;' +
        'background:linear-gradient(135deg,#1a1a2e,#16213e);border:1px solid rgba(24,201,89,0.55);' +
        'border-radius:16px;padding:14px;box-shadow:0 6px 20px rgba(0,0,0,0.65);' +
        'font-family:sans-serif;color:#fff;display:flex;flex-direction:column;gap:10px;';

    const name = data.fromPlayerName || 'Oyuncu';
    const initial = (name[0] || '?').toUpperCase();
    const avatarHtml = data.fromAvatarUrl
        ? '<img src="' + data.fromAvatarUrl + '" style="width:44px;height:44px;border-radius:50%;object-fit:cover;">'
        : '<div style="width:44px;height:44px;border-radius:50%;background:#0f9c42;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:18px;">' + initial + '</div>';
    const subtitle = data.roomId ? 'seni masasına davet ediyor 🎲' : 'seni oyuna davet ediyor 🎲';
    const warningHtml = opts.warning
        ? '<div style="color:#ffb74d;font-size:11.5px;">' + opts.warning + '</div>'
        : '';

    bar.innerHTML =
        '<div style="display:flex;align-items:center;gap:10px;">' +
            avatarHtml +
            '<div style="flex:1;min-width:0;">' +
                '<div style="font-weight:700;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + name + '</div>' +
                '<div style="color:#aaa;font-size:11.5px;">' + subtitle + '</div>' +
                warningHtml +
            '</div>' +
            '<div id="batak-ginv-close" style="cursor:pointer;padding:4px;color:#777;font-size:16px;">✕</div>' +
        '</div>' +
        '<div style="display:flex;gap:8px;">' +
            '<button id="batak-ginv-reject" style="flex:1;height:38px;border:none;border-radius:10px;background:#2A2A3E;color:#999;font-weight:600;font-size:12.5px;cursor:pointer;">Reddet</button>' +
            '<button id="batak-ginv-accept" style="flex:1;height:38px;border:none;border-radius:10px;background:linear-gradient(135deg,#18c959,#0f9c42);color:#fff;font-weight:700;font-size:12.5px;cursor:pointer;">Katıl</button>' +
        '</div>';

    document.body.appendChild(bar);

    bar.querySelector('#batak-ginv-close').onclick = () => bar.remove();
    bar.querySelector('#batak-ginv-accept').onclick = () => {
        bar.remove();
        if (opts.onAccept) opts.onAccept();
    };
    bar.querySelector('#batak-ginv-reject').onclick = () => {
        bar.remove();
        if (opts.onReject) opts.onReject();
    };

    setTimeout(() => {
        if (document.getElementById('batak-game-invite') === bar) bar.remove();
    }, 30000);
};

export const dismissGameInviteDialog = () => {
    const el = document.getElementById('batak-game-invite');
    if (el) el.remove();
};

// Küçük bilgi toast'ı (ör. "X daveti reddetti")
export const showInviteToast = (msg) => {
    ensureDom();
    let t = document.getElementById('batak-invite-toast');
    if (!t) {
        t = document.createElement('div');
        t.id = 'batak-invite-toast';
        document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.display = 'block';
    clearTimeout(t._timer);
    t._timer = setTimeout(() => { t.style.display = 'none'; }, 3200);
};
